class Switch extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      checkboxState: [false, false]
    };

    this.handleCheckboxUpdate = this.handleCheckboxUpdate.bind(this);
  }

  handleCheckboxUpdate(i) {
    let checkboxState = this.state.checkboxState;
    checkboxState[i] = !checkboxState[i];
    this.setState({checkboxState});
  }


  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="switch">
          Switch
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-switch" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Simple switches</h4>
              <p>
                NOTE: Text can be added to the switch's circle by setting it as the data-label
                attribute for the label. If you want this text to change when going from on to
                off you have to do this manually via javascript.
              </p>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="switch-demo">
  Dark theme
  <div class="dark-demo">
    <input
      type="checkbox"
      id="siwtch-example-v"
      class="dark"
    />
    <label for="switch-example-v">
      First switch
    </label>

    <input
      type="checkbox"
      id="siwtch-example-v-on"
      class="dark"
      checked
    />
    <label data-label ="on" for="switch-example-v-on">
      First switch
    </label>

    <input
      type="checkbox"
      id="siwtch-example-v-off"
      class="dark"
    />
    <label data-label="off" for="switch-example-v-off">
      First switch
    </label>
  </div>

  Light theme
  <div>
    <input
      type="checkbox"
      id="switch-example-i"
      class="light"
    />
    <label for="switch-example-i">
      Second switch
    </label>

    <input
      type="checkbox"
      id="switch-example-i-on"
      class="light"
      checke
    />
    <label data-label="on" for="switch-example-i-on">
      Second switch
    </label>

    <input
      type="checkbox"
      id="switch-example-i-off"
      class="light"
    />
    <label data-label="off" for="switch-example-i-off">
      Second switch
    </label>
  </div>

  Disabled
  <div class="dark-demo">
    <input
      type="checkbox"
      id="switch-example-i"
      class="dark-disabled"
    />
    <label for="switch-example-v" data-label="off">
      First switch
    </label>
  </div>
  <div>
    <input
      type="checkbox"
      id="switch-example-i"
      class="light-disabled"
      checked
    />
    <label for="switch-example-i" data-label="on">
      Second switch
    </label>
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.switch-demo {
  div {
    padding: 20px;
    margin-bottom: 20px;
  }

  .dark-demo {
    background: $charcoal-grey;
  }

  .dark {
    @include switch();

    & + label {
      margin-right: 25px;
    }
  }

  .light {
    @include switch(light);

    & + label {
      margin-right: 25px;
    }
  }

  .dark-disabled {
    @include switch($disabled: true);
  }

  .light-disabled {
    @include switch(light, true);
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="switch-demo">

                    Dark theme
                    <div className="dark-demo">
                      <input
                        type="checkbox"
                        name="example" id="siwtch-example-v"
                        value="finish"
                        className="dark"
                        checked={this.state.checkboxState[0]}
                      />
                      <label
                        for="switch-example-v"
                        onClick={() => this.handleCheckboxUpdate(0)}
                      >
                        First switch
                      </label>

                      <input
                        type="checkbox"
                        name="example" id="siwtch-example-v-on"
                        value="finish"
                        className="dark"
                        checked={true}
                      />
                      <label
                        data-label ="on"
                        for="switch-example-v-on"
                        onClick={() => this.handleCheckboxUpdate(0)}
                      >
                        First switch
                      </label>

                      <input
                        type="checkbox"
                        name="example" id="siwtch-example-v-off"
                        value="finish"
                        className="dark"
                        checked={false}
                      />
                      <label
                      data-label="off"
                        for="switch-example-v-off"
                        onClick={() => this.handleCheckboxUpdate(0)}
                      >
                        First switch
                      </label>
                    </div>

                    Light theme
                    <div>
                      <input
                        type="checkbox"
                        name="example"
                        id="switch-example-i"
                        className="light"
                        checked={this.state.checkboxState[1]}
                        value="publish"
                      />
                      <label
                        for="switch-example-i"
                        onClick={() => this.handleCheckboxUpdate(1)}
                      >
                        Second switch
                      </label>

                      <input
                        type="checkbox"
                        name="example"
                        id="switch-example-i-on"
                        className="light"
                        checked={true}
                        value="publish"
                      />
                      <label
                        data-label="on"
                        for="switch-example-i-on"
                        onClick={() => this.handleCheckboxUpdate(1)}
                      >
                        Second switch
                      </label>

                      <input
                        type="checkbox"
                        name="example"
                        id="switch-example-i-off"
                        className="light"
                        checked={false}
                        value="publish"
                      />
                      <label
                        data-label="off"
                        for="switch-example-i-off"
                        onClick={() => this.handleCheckboxUpdate(1)}
                      >
                        Second switch
                      </label>
                    </div>

                    Disabled
                    <div className="dark-demo">
                      <input
                        type="checkbox"
                        name="example"
                        id="switch-example-i"
                        className="dark-disabled"
                        checked={false}
                        value="off"
                      />
                      <label htmlFor="switch-example-v" data-label="off">
                        First switch
                      </label>
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        name="example"
                        id="switch-example-i"
                        className="light-disabled"
                        checked={true}
                        value="on"
                      />
                      <label htmlFor="switch-example-i" data-label="on">
                        Second switch
                      </label>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
